import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  AfterViewInit,
  ElementRef,
} from "@angular/core";

import * as QRCode from "easyqrcodejs";
import { HeaderDefaultModel } from "../shared/model/header-default.model";

@Component({
  selector: "app-qr-code-window",
  templateUrl: "./qr-code-window.component.html",
  styleUrls: ["./qr-code-window.component.css"],
})
export class QrCodeWindowComponent implements OnInit {
  @Output() onCloseDialog: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild("qrcode") qrcode: ElementRef;
  @Input() display: boolean;
  @Input() headerDefault: HeaderDefaultModel;

  headerText = "";
  qrCodeObj: QRCode;

  constructor() {}

  ngOnInit() {}

  close() {
    this.headerText = "";
    this.qrCodeObj.clear();
    this.onCloseDialog.emit({ hasChanges: true });
  }

  save() {
    // Salvar
    var base64content = "";
    for (let child of this.qrcode.nativeElement.children) {
      if (child.alt === "Scan me!") {
        base64content = child.src;
      }
    }

    const blobData = this.convertBase64ToBlobData(
      base64content.split("base64,")[1]
    );
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      //IE
      window.navigator.msSaveOrOpenBlob(
        blobData,
        this.headerDefault.name.toUpperCase() + "_QRCode"
      );
    } else {
      // chrome
      const blob = new Blob([blobData], { type: "image/png" });
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = this.headerDefault.name.toUpperCase() + "_QRCode.png";
      link.click();
    }

    // Fechar
    this.headerText = "";
    this.qrCodeObj.clear();
    this.onCloseDialog.emit({ hasChanges: true });
  }

  convertBase64ToBlobData(
    base64Data: string,
    contentType: string = "image/png",
    sliceSize = 512
  ) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  showModal() {
    // Options
    var options = {
      text: this.headerDefault.qrcode.code,
      logo: "./../../assets/layout/images/avatar.png",
      logoWidth: 75, // widht. default is automatic width
      logoHeight: 75, // height. default is automatic height
      logoBackgroundColor: "white", // Logo backgroud color, Invalid when `logBgTransparent` is true; default is '#ffffff'
      logoBackgroundTransparent: false, // Whether use transparent image, default is false
      title: this.headerDefault.name.toUpperCase(),
      titleColor: "#FF0000", // color. default is "#000"
      titleFont: "bold 2vw Arial",
    };

    // Create new QRCode Object
    this.qrCodeObj = new QRCode(this.qrcode.nativeElement, options);
    this.headerText = this.headerDefault.name;
  }
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/qr-code-window/qr-code-window.component.ts